require('../changeData.scss');

//@vendors
const React = require('react');
const { Form } = require('react-redux-form');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const validator = require('validator');

//@actions
const formActions = require('react-redux-form').actions;
const stepsActions = require('actions/stepsActions');

//@utilities
import { formatText } from 'core/i18n';
const { getReferencePrefixByCountry } = require('utilities/multiLanguageHelper');

//@components
const { InputText } = require('components/inputText/inputText');
const { SignaturePattern } = require('components/changeDataAC/signaturePattern/signaturePattern');
import { RadioButton } from 'components/RadioButton/RadioButton';

export class ItemTelephoneContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponentSignaturePattern: false,
            disabled: true,
            newTel: '',
            confirmTel: '',
            operationType: 'modify_telephone',
        };

        this.buildAddOrSaveButton = this.buildAddOrSaveButton.bind(this);
        this.buildCancelButton = this.buildCancelButton.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toogleDisabled = this.toogleDisabled.bind(this);
        this.handlePhoneOnFocus = this.handlePhoneOnFocus.bind(this);
        this.handleChangeConfirmTel = this.handleChangeConfirmTel.bind(this);
        this.handleChangeNewTel = this.handleChangeNewTel.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.onHandleRadioUpdated = this.onHandleRadioUpdated.bind(this);
        this.validateSameTelephone = this.validateSameTelephone.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { formActions } = this.props;
        formActions.change('userProfile.newCellPhone', '');
        formActions.change('userProfile.newCellPhoneConfirmation', '');
        formActions.change('userProfile.otpOption', 'modify_telephone');
    }

    handlePhoneOnFocus(inputPhone) {
        const newInputPhoneValue = document.getElementById(inputPhone).value.replace(/\s/g, '');

        return (document.getElementById(inputPhone).value = newInputPhoneValue);
    }

    buildAddOrSaveButton() {
        const buttonText = 'Modificar';

        return (
            <button type="submit" className="form__button form__button-primaryB">
                {buttonText}
            </button>
        );
    }

    handleValidateValidFields() {
        const { formActions, userProfileForm } = this.props;

        const requiredFields = ['newCellPhone', 'newCellPhoneConfirmation'];
        const requiredFlag = requiredFields.some(field => !userProfileForm[field].valid);

        if (requiredFlag) {
            requiredFields.forEach(field => {
                if (!userProfileForm[field].valid) {
                    formActions.setValidity(`userProfile.${field}`, { required: false });
                }
            });
        }

        return !requiredFlag;
    }

    handleCompleteFields() {
        const { formActions, userProfileForm } = this.props;

        const requiredFields = ['newCellPhone', 'newCellPhoneConfirmation'];
        const requiredFlag = requiredFields.some(field => userProfileForm[field].value === '');

        if (requiredFlag) {
            requiredFields.forEach(field => {
                if (userProfileForm[field].value === '') {
                    formActions.setValidity(`userProfile.${field}`, { required: false });
                }
            });
        }

        return !requiredFlag;
    }

    validateSameTelephone(cellphone) {
        const { actions, userProfile } = this.props;
        const operationType = 'MODIFY_TELEPHONE';
        const toogleDisabled = this.toogleDisabled;
        const areaCode = getReferencePrefixByCountry();
        const areaCodeClean = areaCode.substr(1);
        const cellPhoneComplete = areaCodeClean + cellphone;
        actions.validateSameDataAlreadyClient(operationType, cellPhoneComplete, userProfile.accessToken, res => {
            if (res) {
                toogleDisabled(false);
            }
        });
    }

    handleSubmit() {
        const isValid = this.handleValidateValidFields();
        const isComplete = this.handleCompleteFields();
        if (isValid && isComplete) {
            this.setState({
                showComponentSignaturePattern: true,
            });
        }
    }

    buildCancelButton() {
        return (
            <button type="button" className="form__button form__button-negativeB" onClick={this.handleCancel}>
                {formatText('button-cancel')}
            </button>
        );
    }

    handleCancel() {
        const { formActions, actions } = this.props;
        actions.validationAlreadyClientReset();
        this.props.onCancel();
        formActions.resetValidity('userProfile.newCellPhone');
        formActions.resetValidity('userProfile.newCellPhoneConfirmation');
        this.setState({
            newTel: '',
            confirmTel: '',
        });
    }

    handleSuccess() {
        this.props.onSuccess();
    }

    handleChangeNewTel(e) {
        const { formActions, actions } = this.props;
        if (e.target.value == '' || e.target.value != this.state.newTel) {
            this.setState({ confirmTel: '' });
            this.toogleDisabled(true);
            actions.validationAlreadyClientReset();
            formActions.resetValidity('userProfile.newCellPhoneConfirmation');
        }
        this.setState({
            newTel: e.target.value,
        });
    }

    toogleDisabled(value) {
        this.setState({
            disabled: value,
        });
    }

    handleChangeConfirmTel(e) {
        this.setState({ confirmTel: e.target.value });
    }

    onHandleRadioUpdated(value) {
        this.setState({
            operationType: value,
        });
    }

    render() {
        const { userProfile, immAlreadyClient } = this.props;
        const cancelButton = this.buildCancelButton();
        const saveButton = this.buildAddOrSaveButton();
        const toogleDisabled = this.toogleDisabled;
        const validateSameTelephone = this.validateSameTelephone;
        const handlePhoneOnFocus = this.handlePhoneOnFocus;
        const operationType = this.state.operationType;
        const onHandleRadioUpdated = this.onHandleRadioUpdated;
        const data = { telephone: this.state.confirmTel };
        let error = '';
        if (immAlreadyClient.get('isValidated') && immAlreadyClient.get('error')) {
            error = formatText('changeData-sameTelephoneError');
        }
        const classInput = error ? 'inner-form__tel-input--error' : 'inner-form__tel-input';

        const modifyTel = (
            <div className="changeData">
                <div className="inner-form">
                    <Form id="formChangeData" model="userProfile" onSubmit={this.handleSubmit}>
                        <div className="title-box__title--blue">
                            <label>{formatText('changeData-modifyTelephone')}</label>
                        </div>
                        <div className="change-data__subtitle__margin">
                            <span>{formatText('changeData-tipTelephone')}</span>
                        </div>
                        <div className="change-data__subtitle">
                            <label>Teléfono móvil actual</label>
                            <p>{userProfile.cellPhone}</p>
                        </div>
                        <div className="md-form-group row form__input">
                            <div className="col-sm-6">
                                <InputText
                                    areaCode={true}
                                    profileModel="userProfile.newCellPhone"
                                    label={formatText('field-cellPhone')}
                                    placeholder={formatText('field-cellPhonePlaceHolder')}
                                    type="tel"
                                    name="newCellPhone"
                                    id="newCellPhone"
                                    inputClass={classInput}
                                    value={this.state.newTel}
                                    onChange={this.handleChangeNewTel}
                                    validations={{
                                        required: value => {
                                            const isRequired = value && value.length;
                                            if (!isRequired) {
                                                const cellPhoneConfirmation =
                                                    document.getElementById('newCellPhoneConfirmation');
                                                formActions.change('userProfile.newCellPhoneConfirmation', '');
                                                cellPhoneConfirmation.value = '';
                                            }

                                            return isRequired;
                                        },
                                        valid: value => {
                                            const isValid = validator.matches(value, /^[6|7][\d ]{10}$/);
                                            const cellPhoneConfirmation =
                                                document.getElementById('newCellPhoneConfirmation');
                                            if (cellPhoneConfirmation.value !== value) {
                                                formActions.change('userProfile.newCellPhoneConfirmation', '');
                                                cellPhoneConfirmation.value = '';
                                                if (isValid) {
                                                    cellPhoneConfirmation.focus();
                                                }
                                            } else if (isValid) {
                                                formActions.setValidity('userProfile.newCellPhoneConfirmation', {
                                                    valid: true,
                                                });
                                            }

                                            return isValid;
                                        },
                                    }}
                                    isValidated={function () {
                                        const newCellPhone = document.getElementById('newCellPhone').value;
                                        validateSameTelephone(newCellPhone);
                                    }}
                                    isNotValidated={function () {
                                        toogleDisabled(true);
                                    }}
                                    onFocus={function () {
                                        handlePhoneOnFocus('newCellPhone');
                                    }}
                                    onBlur={function (value) {
                                        return value.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
                                    }}
                                    messagesError={{
                                        required: formatText('changeData-required'),
                                        valid: formatText('changeData-invalidTelephone'),
                                    }}
                                    {...this.props}
                                />
                                <p className="form__field_error--telephone">{error}</p>
                            </div>
                            <div className="col-sm-6">
                                <InputText
                                    areaCode={true}
                                    profileModel="userProfile.newCellPhoneConfirmation"
                                    label={formatText('field-cellPhoneConfirmation')}
                                    placeholder={formatText('field-cellPhonePlaceHolder')}
                                    type="tel"
                                    name="newCellPhoneConfirmation"
                                    id="newCellPhoneConfirmation"
                                    inputClass="inner-form__tel-input"
                                    pasteDisabled={true}
                                    autoCompleteField={false}
                                    value={this.state.confirmTel}
                                    onChange={this.handleChangeConfirmTel}
                                    validations={{
                                        required: value => value && value.length,
                                        valid: value => {
                                            if (value !== userProfile.newCellPhone) {
                                                return false;
                                            }

                                            return true;
                                        },
                                    }}
                                    onFocus={function () {
                                        handlePhoneOnFocus('newCellPhoneConfirmation');
                                    }}
                                    onBlur={function (value) {
                                        return value.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
                                    }}
                                    messagesError={{
                                        required: formatText('changeData-required'),
                                        valid: value => {
                                            let message;
                                            if (!validator.matches(value, /^[6|7][\d ]{10}$/)) {
                                                message = formatText('changeData-invalidTelephone');
                                            } else if (value !== userProfile.newCellPhone) {
                                                message = formatText('changeData-sameTelephone');
                                            }

                                            return message;
                                        },
                                    }}
                                    disabled={this.state.disabled}
                                    {...this.props}
                                />
                            </div>
                        </div>
                        <div className="md-form-group row form__input">
                            <div className="col-sm-12">
                                <label>¿Cómo deseas recibir el código de confirmación?</label>
                                <RadioButton
                                    profileModel="userProfile.otpOption"
                                    optionsList={[
                                        {
                                            label: `Teléfono móvil actual  ${userProfile.cellPhone}`,
                                            value: 'modify_telephone',
                                        },
                                        {
                                            label: `Email  ${userProfile.email}`,
                                            value: 'modify_telephone_with_email',
                                        },
                                    ]}
                                    isRequired
                                    onChange={function (value) {
                                        onHandleRadioUpdated(value);
                                    }}
                                    focusAnimated
                                    messagesError={{ required: formatText('validation-radioRequired') }}
                                    {...this.props}
                                />
                            </div>
                        </div>
                        <hr className="no-mrg-top" />
                        <div className="inner-form__footer">
                            <div className="inner-form__footer--buttons">
                                {cancelButton}
                                {saveButton}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );

        return (
            <div>
                {this.state.showComponentSignaturePattern ? (
                    <SignaturePattern
                        onSuccess={this.handleSuccess}
                        onCancel={this.handleCancel}
                        data={data}
                        operationType={operationType}
                    />
                ) : (
                    modifyTel
                )}
            </div>
        );
    }
}

module.exports.ItemTelephoneContent = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
        focus: state.focus,
        immAlreadyClient: state.alreadyClientData,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(ItemTelephoneContent);
